import actions from './action';

const initState = {
  loading: false,
  messages: null,
  buttonLoading: false,
  error: null,
  agentData: null,
  totalAgentsData:[],
  show: false
};


export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.ADD_AGENT:
      //console.log("Reducer payload data:", action.payload.data);
      return {
        ...state,
        buttonLoading: true,
      };

    //   return {
    //     ...state,
    //     buttonLoading: false,
    //     show: false,
    //     error: action.payload.error,
    //   };

    case actions.ADD_AGENT_SUCCESS:
      //console.log("Reducer payload data:", action.payload.message);
      return {
        ...state,
        show: false,
        buttonLoading: false,
        totalAgentsData: action.payload.data,
        messages: action.payload.message,
        error: null, // Clear any previous errors
      };
    case actions.ADD_AGENT_FAILED:
      //console.log("Reducer payload error:", action.payload.error);
      return {
        ...state,
        buttonLoading: false,
        show: false,
        error: action.payload.error,
        messages: null, // Clear any previous messages
      };
    case actions.GET_AGENTS_DATA:
     
      return {
        ...state,
        loading: true,
      };
    case actions.GET_AGENTS_DATA_SUCCESS:
      //console.log("Reducer payload data:", action.payload.data);
      // debugger
      return {
        ...state,
        loading: false,
        totalAgentsData: action.payload.data, // The array of agents
      };
    case actions.GET_AGENTS_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case actions.UPDATE_AGENT:
      return {
        ...state,
        buttonLoading: true,
      };

    case actions.UPDATE_AGENT_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        messages: action.payload.message,
        error: null,
        // Update the specific agent in totalAgentsData
        totalAgentsData: state.totalAgentsData.map((agent) =>
          agent.orgId === action.payload.orgId
            ? { ...agent, ...action.payload.updatedData }
            : agent
        ),
      };

    case actions.UPDATE_AGENT_FAILED:
      return {
        ...state,
        buttonLoading: false,
        error: action.payload.error,
        messages: null,
      };
    default:
      return state;
  }

}